import { Component, OnInit, Input } from '@angular/core';
import { BPProfilesOEMDataService, ICLF } from '../bp-profiles-oem-data.service';
import * as _ from 'underscore';
import { FormattingService } from '../../../../../shared/services/formatting.service';

interface IExtendedCLF extends ICLF {
  formattedFixAmount?:string;
  formattedOtherLocalUplift?:string;
}

@Component({
  selector: 'clf-detail',
  template: `
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th translate>BPPROFILES.OEM.CLF.CATEGORY</th>
          <th translate>BPPROFILES.OEM.CLF.IMPORT_DUTY</th>
          <th translate>BPPROFILES.OEM.CLF.FREIGHT</th>
          <th translate>BPPROFILES.OEM.CLF.BROKER_FEE</th>
          <th translate>BPPROFILES.OEM.CLF.INSURANCE</th>
          <th translate>BPPROFILES.OEM.CLF.DISTRIBUTOR_MARGIN</th>
          <th translate>BPPROFILES.OEM.CLF.OTHER_LOCAL_UPLIFT</th>
          <th translate>BPPROFILES.OEM.CLF.TOTAL_CLF</th>
          <th translate>BPPROFILES.OEM.CLF.FIX</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!clfList.length">
          <td colspan="9" class="text-center" translate>BPPROFILES.OEM.NO_DATA</td>
        </tr>
        
        <ng-container *ngFor="let clf of clfList; let idx = index;">
          <tr>
            <td rowspan="2">{{clf.category}}</td>
            <td class="text-end">{{(clf.importDuty || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{(clf.freight || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{(clf.brokerFee || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{(clf.insurance || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{(clf.distributorMargin || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{clf.formattedOtherLocalUplift}}</td>
            <td class="text-end">{{(clf.vendorClf || 0) | format: 'formatPct' }}</td>
            <td class="text-end">{{clf.formattedFixAmount}}</td>
          </tr>
          <tr *ngIf="idx === (clfList.length - 1)">
            <td colspan="8">{{clf.comments}}</td>
          </tr>
        </ng-container> 
      </tbody>
    </table>
  `
})
export class CLFDetailComponent implements OnInit {
  @Input() public countryId:number;
  @Input() public oemCompanyId:number;

  public loading:boolean;
  public clfList:IExtendedCLF[] = [];

  constructor(
    private bpProfilesOEMDataService:BPProfilesOEMDataService,
    private formattingService:FormattingService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.loading = true;
    this.bpProfilesOEMDataService.listCLF(this.countryId, this.oemCompanyId)
      .then((list:IExtendedCLF[]) => {
        this.clfList = _.map(list, (clf:IExtendedCLF) => {
          clf.formattedOtherLocalUplift = this.formattingService.formatPct(clf.otherLocalUplift) + (clf.otherUpliftDescription? `(${clf.otherUpliftDescription})` : '');
          clf.formattedFixAmount = this.formattingService.formatAmount(clf.fixAmount, (clf.currency || clf.country?.currency));
          return clf;
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}